import { HEALTH_STATUS } from '@/const';
import React from 'react';
import { cn } from '@/lib/utils';
import { FaultReasons } from './FaultReasons';

interface AssetHealthStatusIndicatorProps {
  healthStatus: HEALTH_STATUS;
  isVertical?: boolean;
  showReasons?: boolean;
  counterOnly?: boolean;
  isMonitored?: boolean;
  reasons?: string[];
  size?: 'md' | 'sm';
}

export const AssetHealthStatusIndicator = ({
  healthStatus,
  isVertical = false,
  reasons,
  size,
  counterOnly,
  showReasons,
}: AssetHealthStatusIndicatorProps) => {
  return (
    <div className={cn(`flex`, ` ${isVertical ? 'flex-col justify-center items-start gap-1' : 'items-center gap-2 '}`)}>
      <HealthStatus healthStatus={healthStatus} className="text-xs font-semibold" />
      <FaultReasons reasons={reasons} counterOnly={counterOnly} showReasons={showReasons} size={size} />
    </div>
  );
};

export const HealthStatus = ({ healthStatus, className }: { healthStatus: HEALTH_STATUS; className?: string }) => {
  return (
    <div className={cn(`text-${healthStatus}  capitalize`, className)} data-testid={'health_status'}>
      {healthStatus === 'na' ? 'N/A' : healthStatus}
    </div>
  );
};
